
import Navbar from "@/components/Navbar";
import NoDataAlert from "@/components/analytics/NoDataAlert";
import { useAnalyticsData } from "./useAnalyticsData";
import AnalyticsHeader from "./AnalyticsHeader";
import AnalyticsContent from "./AnalyticsContent";

const Analytics = () => {
  const {
    timeRange,
    setTimeRange,
    selectedProductId,
    setSelectedProductId,
    selectedGroupId,
    handleGroupChange,
    usageRecords,
    stockUpdates,
    isAnalyticsLoading,
    products,
    groups,
    isLoading
  } = useAnalyticsData();

  // Show loading state during data fetch
  if (isLoading || isAnalyticsLoading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        <Navbar />
        <main className="max-w-7xl mx-auto px-4 py-8">
          <h1 className="text-2xl font-bold mb-6">Analytics</h1>
          <div className="flex justify-center items-center p-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 dark:border-gray-50"></div>
          </div>
        </main>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        <Navbar />
        <main className="max-w-7xl mx-auto px-4 py-8">
          <h1 className="text-2xl font-bold mb-6">Analytics</h1>
          <NoDataAlert />
        </main>
      </div>
    );
  }

  const selectedProduct = products.find(p => p.id === selectedProductId);
  const filteredUsageRecords = usageRecords;
  const filteredStockUpdates = stockUpdates;

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 py-8">
        <AnalyticsHeader
          products={products}
          groups={groups}
          selectedProductId={selectedProductId}
          setSelectedProductId={setSelectedProductId}
          selectedGroupId={selectedGroupId}
          handleGroupChange={handleGroupChange}
          timeRange={timeRange}
          setTimeRange={setTimeRange}
        />

        <AnalyticsContent
          selectedGroupId={selectedGroupId}
          groups={groups}
          products={products}
          usageRecords={usageRecords}
          timeRange={timeRange}
          selectedProduct={selectedProduct}
          stockUpdates={stockUpdates}
          filteredUsageRecords={filteredUsageRecords}
          filteredStockUpdates={filteredStockUpdates}
        />
      </main>
    </div>
  );
};

export default Analytics;
